import React, {useEffect, useRef, useState} from 'react'
import {Checkbox, Col, Form, Row, Typography} from 'antd'
import FormErrorMessage from '../base/FormErrorMessage'
import {validateMessages} from '../../app/util'
import NewPiecesFormButton from './NewPiecesFormButton'
import {loadForm} from '../../app/cacheUtil'
import BusinessPrints from '../../asset/image/business-prints.jpeg'
import BusinessLicense from '../../asset/image/business-license.jpeg'
import BusinessCommission from '../../asset/image/business-commission.jpeg'
import BusinessOriginal from '../../asset/image/business-original.jpeg'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

export default (props) => {
    const [validateError, setValidateError] = useState([])
    const formRef = useRef(null)

    const onFinishFailed = ({values, errorFields, outOfDate}) => {
        setValidateError(errorFields)
        window.scrollTo(0, 0)
        window.scrollTop = 0
    }

    const businessTypes = [
        {
            label: 'Sell Original',
            value: 'original',
            img: <img width={240} height={160} src={BusinessOriginal} alt={"original"}/>
        },
        {
            label: 'Sell Print',
            value: 'prints',
            img: <img width={240} height={160} src={BusinessPrints} alt={"prints"}/>
        },
        {
            label: 'Sell Commission',
            value: 'commission',
            img: <img width={240} height={160} src={BusinessCommission} alt={"commission"}/>
        },
        {
            label: 'License Art',
            value: 'licensing',
            img: <img width={240} height={160} src={BusinessLicense} alt={"licensing"}/>
        }
    ]

    useEffect(() => {
        const cache = loadForm(props.formId)
        if (cache) {
            formRef.current?.setFieldsValue(cache)
        }
    }, [])

    return (
        <>
            <FormErrorMessage error={validateError}/>
            <Form
                colon={false}
                ref={formRef}
                labelAlign='left'
                layout={'vertical'}
                onFinish={props.onFinish}
                validateMessages={validateMessages}
                onFinishFailed={onFinishFailed}
                style={{
                    marginTop: '16px'
                }}
            >
                <Row
                    style={{
                        paddingLeft: '3vw',
                        paddingRight: '3vw',
                        maxWidth: 1280,
                        height: '100%',
                        flexDirection: 'row'
                    }}
                >
                    <Col
                        xs={24}
                        sm={24}
                        md={24}
                        style={{
                            marginTop: 32,
                            paddingLeft: 18,
                            paddingRight: 18,
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        <Form.Item
                            name='used_type'
                            label={<Title level={4}>Collaboration Type</Title>}
                            style={{display: 'block', width: '100%'}}
                            rules={[
                                {
                                    required: !is_admin_user(props)
                                }
                            ]}
                        >
                            <Checkbox.Group style={{display: 'flex', width: '100%', gap: 4, flexWrap: 'wrap'}}>
                                {businessTypes.map((type) => {
                                    return (
                                        <div style={{padding: 4}}>
                                            {type.img}
                                            <center>
                                                <h5>
                                                    {type.label}&nbsp;<Checkbox label={type.label} value={type.value}/>
                                                </h5>
                                            </center>
                                        </div>
                                    )
                                })}
                            </Checkbox.Group>
                        </Form.Item>
                    </Col>
                    <NewPiecesFormButton {...props} stepperCount={2}/>
                </Row>
            </Form>
        </>
    )
}
